import { createFileRoute, redirect } from "@tanstack/react-router";

/** The plans are listed on the client's Plans tab, so the breadcrumb step above a plan leads there. */
// oxlint-disable-next-line rules/require-route-crumb -- redirects before it renders, so the crumb comes from the layout route
export const Route = createFileRoute("/(private)/trainees/$clientId/training-plans/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/trainees/$clientId/plans", params, replace: true });
  },
});
